import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { appConfig } from '../../../../config';

const BASE_GROUP_CLASSIFICATION_URL = '/entidadesfinancieras/clasificacionGrupo';

export const groupClassificationApi = createApi({
  reducerPath: 'groupClassificationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: appConfig.API_NODE_URL,
    prepareHeaders: (headers: Headers) => {
      const APP_TOKEN = 'app_token';
      const token = localStorage.getItem(APP_TOKEN);

      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }

      return headers;
    },
    credentials: 'include',
  }),
  tagTypes: ['GroupClassification'],
  endpoints: (builder) => ({
    // placeholder endpoints; will be implemented when backend exists
    getGroupClassifications: builder.query<any, void>({
      query: () => ({ url: BASE_GROUP_CLASSIFICATION_URL, method: 'GET' }),
      providesTags: ['GroupClassification'],
    }),
    createGroupClassification: builder.mutation<any, any>({
      query: (data) => ({
        url: BASE_GROUP_CLASSIFICATION_URL,
        method: 'POST',
        body: { Content: data },
      }),
      invalidatesTags: ['GroupClassification'],
    }),
    updateGroupClassification: builder.mutation<any, any>({
      query: (data) => ({
        url: BASE_GROUP_CLASSIFICATION_URL,
        method: 'PUT',
        body: { Content: data },
      }),
      invalidatesTags: ['GroupClassification'],
    }),
    deleteGroupClassification: builder.mutation<any, number>({
      query: (id) => ({
        url: `${BASE_GROUP_CLASSIFICATION_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['GroupClassification'],
    }),
  }),
});

export const { useGetGroupClassificationsQuery, useCreateGroupClassificationMutation, useUpdateGroupClassificationMutation, useDeleteGroupClassificationMutation } = groupClassificationApi;

export default groupClassificationApi;
